export default __webpack_public_path__ + "static/media/map.2b3fdd3a.png";